import { viralVideos } from '@/mocks/homeData';
import type { ViralVideo } from '@/pages/home/types';

const videos = viralVideos as ViralVideo[];

export default function ViralSection() {
  return (
    <section id="viral" className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-6xl">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-sm text-primary-600">
            <i className="ri-rocket-2-line"></i>
            站内爆款
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">正在被大量转发的爆款内容</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            以下是近一周增长势头最明显的几条内容。它们的共同点是切口具体、信息密度高，通常在发布后 48 小时内进入推荐的快车道。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:gap-5">
          {videos.map((video) => (
            <article
              key={video.title}
              className="group overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-52">
                <img
                  src={video.cover}
                  alt={`${video.title} 视频封面`}
                  title={`${video.title} - 西瓜视频爆款内容`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs text-background-50">
                  <i className="ri-flashlight-fill"></i>
                  {video.badge}
                </span>
                <span className="absolute bottom-3 right-3 rounded bg-black/70 px-2 py-0.5 text-xs text-background-50">
                  {video.duration}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm text-foreground-950 md:text-base">{video.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{video.summary}</p>
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500 md:text-sm">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {video.author}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-play-circle-line"></i>
                    {video.plays}
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-accent-800">
                    {video.category}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}